import { render } from "./ModuleMosaic.vue?vue&type=template&id=647e28c8"
import script from "./ModuleMosaic.vue?vue&type=script&lang=js"
export * from "./ModuleMosaic.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__